var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "send_736161",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.892,
    height: 33.558,
    viewBox: "0 0 38.892 33.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28934",
    "data-name": "Group 28934",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39846",
    "data-name": "Path 39846",
    d: "M36.575,48.421,5.2,35.4A3.756,3.756,0,0,0,.118,39.8L3.2,51.889.118,63.982a3.756,3.756,0,0,0,5.078,4.4l31.379-13.02a3.755,3.755,0,0,0,0-6.937ZM35.7,53.253,4.323,66.273a1.477,1.477,0,0,1-2-1.729L5.263,53.029H16.586a1.139,1.139,0,1,0,0-2.279H5.263L2.326,39.234a1.477,1.477,0,0,1,2-1.729L35.7,50.525a1.477,1.477,0,0,1,0,2.728Z",
    transform: "translate(0 -35.111)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSendIcon);
export default __webpack_public_path__ + "static/media/message_send_icon.7579d4417ff0600b8a82c0d1849e957d.svg";
export { ForwardRef as ReactComponent };